import { MobileOpCode } from 'graphql/generated/graphqlTypes';
import { AccessFilterAction } from 'v2/utils/accessEvents';
import { EventsFilter } from './eventFilterTypes';

export const eventsFilterDefault: EventsFilter = {
  access: null,
  detail: null,
  dateStart: null,
  dateEnd: null,
  user: null,
  device: null
};

/** Days the date range reaches back from the end date when only an end date is chosen. */
export const DEFAULT_DATE_RANGE_DAYS = 30;

export const ACCESS_FILTER_ITEMS: { key: string; value: AccessFilterAction }[] = [
  { key: 'granted', value: MobileOpCode.AccessGranted },
  { key: 'denied', value: MobileOpCode.AccessDenied },
  { key: 'pending', value: MobileOpCode.ResultPending }
];
